import { withAuthenticationRequired } from "@auth0/auth0-react";
import { Button, Grid, Box, Tooltip, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import PageTitle from "../components/PageTitle";
import { useTranslation } from "react-i18next";
import { Add, Refresh } from "@mui/icons-material";
import LabelsTable from "../components/Tables/Labels";
import { useState } from "react";
import { UtilityService } from "../services/UtilityService";
import { useBillingCheck } from "../hooks/useBillingCheck";
import DocumentTitle from "../components/DocumentTitle";
import useLabels from "../hooks/useLabels";
import LabelEditDialog from "../components/Dialogs/labelsEdit";

function Labels() {
  // Check billing status on page load
  useBillingCheck();

  const selectedOrganisation = useSelector(
    (state) => state.selectedOrganisation
  );

  const isMobile = useSelector((state) => state.isMobile);
  const theme = useTheme();
  const { t } = useTranslation("common");
  const { data: labels = [], refetch: refetchLabels } = useLabels(
    selectedOrganisation?.id
  );

  const [addOpen, setAddOpen] = useState(false);

  const handleRefresh = () => {
    refetchLabels();
    UtilityService.updateSnackbarMessage(
      t("common.refreshed_at", {
        type: t("labels.index"),
        time: new Date().toLocaleTimeString(),
      })
    );
  };

  return (
    <>
      <DocumentTitle
        title={t("labels.index")}
        selectedOrganisation={selectedOrganisation}
      />
      <Grid size={{ xs: 12 }}>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent={isMobile ? "flex-start" : "flex-end"}
          alignItems="center"
        >
          <PageTitle
            theme={theme}
            title={
              selectedOrganisation && selectedOrganisation.name
                ? selectedOrganisation.name + " " + t("labels.index")
                : t("labels.index")
            }
            subTitle={t("common.labels_in_organisation", {
              count: labels.length,
            })}
          />
          <Tooltip title={t("labels.add")} placement="top" arrow>
            <Button
              sx={{ mr: 1 }}
              variant="outlined"
              color={theme.palette.mode === "dark" ? "primary" : "secondary"}
              onClick={() => setAddOpen(true)}
            >
              <Add />
            </Button>
          </Tooltip>

          <Tooltip title={t("labels.refresh")} placement="top" arrow>
            <Button
              variant="outlined"
              color={theme.palette.mode === "dark" ? "primary" : "secondary"}
              onClick={handleRefresh}
            >
              <Refresh />
            </Button>
          </Tooltip>
        </Box>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <LabelsTable />

        <LabelEditDialog
          open={addOpen}
          handleClose={() => {
            setAddOpen(false);
            handleRefresh();
          }}
        />
      </Grid>
    </>
  );
}

export default withAuthenticationRequired(Labels);
